/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CancelGoodsItem } from './CancelGoodsItem';
import {
    CancelGoodsItemFromJSON,
    CancelGoodsItemFromJSONTyped,
    CancelGoodsItemToJSON,
    CancelGoodsItemToJSONTyped,
} from './CancelGoodsItem';
import type { CouponPayItem } from './CouponPayItem';
import {
    CouponPayItemFromJSON,
    CouponPayItemFromJSONTyped,
    CouponPayItemToJSON,
    CouponPayItemToJSONTyped,
} from './CouponPayItem';

/**
 * 
 * @export
 * @interface PurchaseCancelBillCreateReqVo
 */
export interface PurchaseCancelBillCreateReqVo {
    /**
     * 用户ID
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    userId: number;
    /**
     * 原订单编码（发起代买取消的订单，部分取消时由该订单拆分出取消订单）
     * @type {string}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    orderCode: string;
    /**
     * 预检时的订单状态（由precheck接口返回，保存时回传用于一致性校验）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    orderStatus?: number;
    /**
     * 预检时的订单修改时间（由precheck接口返回，保存时回传用于乐观锁校验）
     * @type {string}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    orderUpdateTime?: string;
    /**
     * 预检时的商品数量（由precheck接口返回，保存时回传用于商品一致性校验）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    goodsCount?: number;
    /**
     * 打开取消窗口时预检返回的订单及商品快照标识，保存时必须原样回传，数据变更需刷新
     * @type {string}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    orderDataToken?: string;
    /**
     * 货币代码（手续费账单与退款账单共用）
     * @type {string}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    currencyCode: string;
    /**
     * 代买取消商品列表（部分取消时传入取消商品；全部取消传入全部商品，由后端按剩余商品判断是否分单）
     * @type {Array<CancelGoodsItem>}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    cancelGoodsList?: Array<CancelGoodsItem>;
    /**
     * 代买取消手续费账单(billType=2)总金额，0表示免手续费（账单创建后自动已支付并逻辑删除）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    cancelFeeAmount: number;
    /**
     * 代买取消退款账单(billType=20)总金额；未支付阶段不生成退款账单，应传0
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    refundAmount: number;
    /**
     * 退款账单货物金额（不传默认等于refundAmount，与refundAdditionalServiceAmount、refundTransferAmount之和须等于refundAmount）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    refundGoodsAmount?: number;
    /**
     * 退款账单附加服务金额（不传默认为0）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    refundAdditionalServiceAmount?: number;
    /**
     * 退款账单钱包转账金额（不传默认为0）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    refundTransferAmount?: number;
    /**
     * 退款预存款支付金额（退回钱包的金额，无预存款退款时传0）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    walletPay: number;
    /**
     * 退款卡支付金额（不传默认为0）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    cardPay?: number;
    /**
     * 退款赠送金支付金额（不传默认为0）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    bonusPay?: number;
    /**
     * 回退积分数（不传默认为0）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    pointsPay?: number;
    /**
     * 回退优惠券列表（仅退款账单使用；后端落库前统一替换billId为退款账单id）
     * @type {Array<CouponPayItem>}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    couponPays?: Array<CouponPayItem>;
    /**
     * 退款金额（退款账单return_amount字段，不传默认为0）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    returnAmount?: number;
    /**
     * 汇率（非必填，不传则自动获取，两张账单共用）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    exchangeRate?: number;
    /**
     * 仓库ID（非必填，传订单current_warehouse_id，两张账单共用）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    warehouseId?: number;
    /**
     * 备注（两张账单共用）
     * @type {string}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    remark?: string;
    /**
     * 创建账单的管理员ID，只有管理员主动操作时才有值（两张账单共用）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    createStaffId?: number;
    /**
     * 是否发送短信：1-发送，0-不发送（两张账单共用）
     * @type {number}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    sendSms?: number;
    /**
     * 手续费账单明细通用内容（JSON字符串，对应原手续费账单创建的detailContent）
     * @type {string}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    cancelFeeDetailContent?: string;
    /**
     * 退款账单明细通用内容（JSON字符串，对应原退款账单创建的detailContent）
     * @type {string}
     * @memberof PurchaseCancelBillCreateReqVo
     */
    refundDetailContent?: string;
}

/**
 * Check if a given object implements the PurchaseCancelBillCreateReqVo interface.
 */
export function instanceOfPurchaseCancelBillCreateReqVo(value: object): value is PurchaseCancelBillCreateReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('orderCode' in value) || value['orderCode'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('cancelFeeAmount' in value) || value['cancelFeeAmount'] === undefined) return false;
    if (!('refundAmount' in value) || value['refundAmount'] === undefined) return false;
    if (!('walletPay' in value) || value['walletPay'] === undefined) return false;
    return true;
}

export function PurchaseCancelBillCreateReqVoFromJSON(json: any): PurchaseCancelBillCreateReqVo {
    return PurchaseCancelBillCreateReqVoFromJSONTyped(json, false);
}

export function PurchaseCancelBillCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseCancelBillCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'orderCode': json['orderCode'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'orderUpdateTime': json['orderUpdateTime'] == null ? undefined : json['orderUpdateTime'],
        'goodsCount': json['goodsCount'] == null ? undefined : json['goodsCount'],
        'orderDataToken': json['orderDataToken'] == null ? undefined : json['orderDataToken'],
        'currencyCode': json['currencyCode'],
        'cancelGoodsList': json['cancelGoodsList'] == null ? undefined : ((json['cancelGoodsList'] as Array<any>).map(CancelGoodsItemFromJSON)),
        'cancelFeeAmount': json['cancelFeeAmount'],
        'refundAmount': json['refundAmount'],
        'refundGoodsAmount': json['refundGoodsAmount'] == null ? undefined : json['refundGoodsAmount'],
        'refundAdditionalServiceAmount': json['refundAdditionalServiceAmount'] == null ? undefined : json['refundAdditionalServiceAmount'],
        'refundTransferAmount': json['refundTransferAmount'] == null ? undefined : json['refundTransferAmount'],
        'walletPay': json['walletPay'],
        'cardPay': json['cardPay'] == null ? undefined : json['cardPay'],
        'bonusPay': json['bonusPay'] == null ? undefined : json['bonusPay'],
        'pointsPay': json['pointsPay'] == null ? undefined : json['pointsPay'],
        'couponPays': json['couponPays'] == null ? undefined : ((json['couponPays'] as Array<any>).map(CouponPayItemFromJSON)),
        'returnAmount': json['returnAmount'] == null ? undefined : json['returnAmount'],
        'exchangeRate': json['exchangeRate'] == null ? undefined : json['exchangeRate'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'createStaffId': json['createStaffId'] == null ? undefined : json['createStaffId'],
        'sendSms': json['sendSms'] == null ? undefined : json['sendSms'],
        'cancelFeeDetailContent': json['cancelFeeDetailContent'] == null ? undefined : json['cancelFeeDetailContent'],
        'refundDetailContent': json['refundDetailContent'] == null ? undefined : json['refundDetailContent'],
    };
}

export function PurchaseCancelBillCreateReqVoToJSON(json: any): PurchaseCancelBillCreateReqVo {
    return PurchaseCancelBillCreateReqVoToJSONTyped(json, false);
}

export function PurchaseCancelBillCreateReqVoToJSONTyped(value?: PurchaseCancelBillCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'orderCode': value['orderCode'],
        'orderStatus': value['orderStatus'],
        'orderUpdateTime': value['orderUpdateTime'],
        'goodsCount': value['goodsCount'],
        'orderDataToken': value['orderDataToken'],
        'currencyCode': value['currencyCode'],
        'cancelGoodsList': value['cancelGoodsList'] == null ? undefined : ((value['cancelGoodsList'] as Array<any>).map(CancelGoodsItemToJSON)),
        'cancelFeeAmount': value['cancelFeeAmount'],
        'refundAmount': value['refundAmount'],
        'refundGoodsAmount': value['refundGoodsAmount'],
        'refundAdditionalServiceAmount': value['refundAdditionalServiceAmount'],
        'refundTransferAmount': value['refundTransferAmount'],
        'walletPay': value['walletPay'],
        'cardPay': value['cardPay'],
        'bonusPay': value['bonusPay'],
        'pointsPay': value['pointsPay'],
        'couponPays': value['couponPays'] == null ? undefined : ((value['couponPays'] as Array<any>).map(CouponPayItemToJSON)),
        'returnAmount': value['returnAmount'],
        'exchangeRate': value['exchangeRate'],
        'warehouseId': value['warehouseId'],
        'remark': value['remark'],
        'createStaffId': value['createStaffId'],
        'sendSms': value['sendSms'],
        'cancelFeeDetailContent': value['cancelFeeDetailContent'],
        'refundDetailContent': value['refundDetailContent'],
    };
}

